exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description-toggle > *{\r\n    display: block !important;\r\n    vertical-align: unset !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/account-settings/account-settings.component.css
// module id = ../../../../../src/app/profile-update/account-settings/account-settings.component.css
// module chunks = main